import { z } from 'zod';

export const exerciseSchema = z.object({
  id: z.number().int().optional(),
  nome: z.string().min(3, "O nome deve ter no mínimo 3 caracteres"),
  descricao: z.string().optional(),
  idGrupo: z.number().int().refine( value => value > 0 , 'Selecione um grupo muscular'),
  unidade: z.object({
    id: z.union([z.number().int(), z.string()])
  })
});

export type ExerciseFormData = z.infer<typeof  exerciseSchema>